<div class="fw-bold bg-white p-3 rounded-5 mb-5 shadow">
  <div class="d-flex justify-content-between">
    <div>
      <label for="information" class="labelInformation">
        List of Tickets
      </label>
    </div>
    <div class="col btn-back text-end">
      <a class="btn btn-secondary" [routerLink]="['/home']">Back</a>
    </div>
  </div>
  <div class="mb-3 float-end">
    <input [(ngModel)]="viewArchivedTickets" type="checkbox" class="btn-check" name="options-outlined" id="viewArchivedTickets" autocomplete="off" (change)="onCheckboxChange($event)">
    <label class="btn btn-outline-success" for="viewArchivedTickets" [appTooltip]="'View archived Tickets'"><i class="bi bi-archive"></i></label>
  </div>

  <app-table-control [data]="filteredTickets" [columns]="columns" [pageSize]="5" [showCheckboxes]="true"
    [showCheckboxes]="false" (actionClick)="onAction($event)" [pageSize]="15" [actionButtons]="actionButtons"
    [showActions]="true">
  </app-table-control>
</div>



<app-modal-alert-control [id]="'ticketArchiveConfirmationAlert'" [header]="'Confirmation'"
  [body]="'Are you sure you want to archive this ticket?'" [okButtonText]="'Archive'"
  (onOkButtonClick)="onTicketArchiveConfirmed()"></app-modal-alert-control>